/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-unused-vars */
import * as React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import "./Dasboard.css";
import { GrClose } from "react-icons/gr";
import { Menu, MenuItem } from "@mui/material";
import Routing from "../../Routing";
import { useEffect } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
} from "../../Constant/Global";
import axios from "axios";
import { useState } from "react";
import { useMainContext } from "../../context/MainContext";

const drawerWidth = 240;

const formatDateTime = (dateTime) => {
  const date = new Date(dateTime);

  const dateOptions = {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  };

  const timeOptions = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const formattedDate = date.toLocaleDateString("en-US", dateOptions);
  const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

  return `${formattedDate}, ${formattedTime}`;
};

export default function ResponsiveDrawer(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const hideClasses = location.pathname === "/login";
  const isPrintPage = location.pathname === "/user_details";
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [Open, setOpen] = React.useState(false);
  const [masterOpen, setMasterOpen] = React.useState(false);
  const [PagesOpen, setPagesOpen] = React.useState(false);
  const [adminOpen, setAdminOpen] = React.useState(false);
  const [websiteConfigOpen, setWebsiteConfigOpen] = React.useState(false);
  const [activeItem, setActiveItem] = React.useState("item1");
  const navigate = useNavigate("");
  const [currentDateTime, setCurrentDateTime] = React.useState(new Date());
  const [selectedImage1, setSelectedImage1] = useState(null);
  const userDetails = sessionStorage.getItem("info");
  const useInfo = JSON.parse(userDetails);
  const formattedDateTime = formatDateTime(currentDateTime);
  const [day, rest] = formattedDateTime.split(", ", 1);
  const restDateTime = formattedDateTime.slice(day.length + 2);
  const { setThemeLogo } = useMainContext();
  const [isHomeOpen, setIsHomeOpen] = React.useState(false);

  // logo for admin
  useEffect(() => {
    const handleGetDetailsById = async () => {
      const user_id = useInfo?.id;
      try {
        const response = await axios.get(
          API_BASE_URL + `super-admin/profile/${user_id}`,
          {
            auth: {
              username: API_AUTH_USERNAME,
              password: API_AUTH_PASSWORD,
            },
          }
        );
        if (response.data.status) {
          if (response.data.data.image) {
            setSelectedImage1(response.data.data.image);
            setThemeLogo(response.data.data.image);
          }
        }
      } catch (error) {
        console.log("error occured getting data", error);
      }
    };
    handleGetDetailsById();
  }, [useInfo?.id]);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("info") === null) {
      console.log("please login first");
      navigate("/login");
    }
  }, []);

  const handleCloseProfile = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("info");
    setAnchorEl(null);
    navigate("/login");
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleCloseMenu = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClick = (item) => {
    setActiveItem(item);
  };
  const drawer = (
    <div
      style={{
        paddingBottom: "5rem",
        backgroundColor: "#181818",
        display: isPrintPage ? "none" : "",
      }}
    >
      <style>
        {`
        /* Style the scrollbar */
        ::-webkit-scrollbar {
          width: 1px;
        }

        
      `}
      </style>
      <Toolbar
        className="ps-0 d-flex justify-content-between align-items-center"
        sx={{ height: "40px" }}
        style={{ backgroundColor: "#181818" }}
      >
        <div className="d-flex justify-content-center w-100">
          <Link className="admin-logo-sec" to="/">
            <img
              className="admin-logo"
              src={selectedImage1 !== null && selectedImage1}
              alt=""
            />
          </Link>
        </div>
        <button className="close_menu_btn" onClick={handleCloseMenu}>
          <GrClose color="#625C5C" />
        </button>
      </Toolbar>
      <Divider></Divider>
      <List>
        {/* website configuration */}
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => setWebsiteConfigOpen(!websiteConfigOpen)}
          >
            <ListItemIcon className="icon_bg">
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333ZM7.5 15.8333H4.16667V12.5H7.5V15.8333ZM16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5ZM15.8333 7.5H12.5V4.16667H15.8333V7.5ZM16.6667 13.3333H15V11.6667C15 11.4457 14.9122 11.2337 14.7559 11.0774C14.5996 10.9211 14.3877 10.8333 14.1667 10.8333C13.9457 10.8333 13.7337 10.9211 13.5774 11.0774C13.4211 11.2337 13.3333 11.4457 13.3333 11.6667V13.3333H11.6667C11.4457 13.3333 11.2337 13.4211 11.0774 13.5774C10.9211 13.7337 10.8333 13.9457 10.8333 14.1667C10.8333 14.3877 10.9211 14.5996 11.0774 14.7559C11.2337 14.9122 11.4457 15 11.6667 15H13.3333V16.6667C13.3333 16.8877 13.4211 17.0996 13.5774 17.2559C13.7337 17.4122 13.9457 17.5 14.1667 17.5C14.3877 17.5 14.5996 17.4122 14.7559 17.2559C14.9122 17.0996 15 16.8877 15 16.6667V15H16.6667C16.8877 15 17.0996 14.9122 17.2559 14.7559C17.4122 14.5996 17.5 14.3877 17.5 14.1667C17.5 13.9457 17.4122 13.7337 17.2559 13.5774C17.0996 13.4211 16.8877 13.3333 16.6667 13.3333ZM8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5ZM7.5 7.5H4.16667V4.16667H7.5V7.5Z"
                  fill={
                    location.pathname === "/sub-header" ||
                    location.pathname === "/" ||
                    location.pathname === "/promotion-header" ||
                    location.pathname === "/header" ||
                    location.pathname === "/offer-pattern" ||
                    location.pathname === "/slider-pattern" ||
                    location.pathname === "/category-pattern" ||
                    location.pathname === "/footer-pattern" ||
                    location.pathname === "/promises" ||
                    location.pathname === "/new-arrival" ||
                    location.pathname === "/best-seller" ||
                    location.pathname === "/hot-deal"
                      ? "#F99F21"
                      : "white"
                  }
                />
              </svg>
            </ListItemIcon>
            <ListItemText className="link_tag_sidebar ">
              Website Configuration
            </ListItemText>
            <span className="pe-3">
              {" "}
              {websiteConfigOpen ? (
                <KeyboardArrowRightIcon className="fs-6 text-white" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6 text-white" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {websiteConfigOpen && (
          <List>
            {/* start master dropdown */}
            <ListItem disablePadding>
              <ListItemButton onClick={() => setMasterOpen(!masterOpen)}>
                <ListItemIcon></ListItemIcon>
                <ListItemText className="link_tag_sidebar ">Home</ListItemText>
                <span className="pe-3">
                  {" "}
                  {masterOpen ? (
                    <KeyboardArrowRightIcon className="fs-6 text-white" />
                  ) : (
                    <KeyboardArrowDownIcon className="fs-6 text-white" />
                  )}
                </span>
              </ListItemButton>
            </ListItem>
            {masterOpen && (
              <List>
                <Link to="/login-popup" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/login-popup" ||
                      location.pathname === "/"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item11")}
                  >
                    <ListItemButton>
                      <ListItemIcon className="icon_bg"></ListItemIcon>
                      <ListItemText className="custom-font">
                        Login Pop Up
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/promotion-header" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/promotion-header"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item11")}
                  >
                    <ListItemButton>
                      <ListItemIcon className="icon_bg"></ListItemIcon>
                      <ListItemText className="custom-font">
                        Promotion Message Header
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>

                <Link to="/sub-header" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/sub-header"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item2")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        Sub Header
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>

                <Link to="/header" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/header"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item55")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        {" "}
                        Header
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/slider-pattern" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/slider-pattern"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item55_00")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        Slider
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/category-pattern" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/category-pattern"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item55")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        {" "}
                        Category
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>

                <Link to="/offer-pattern" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/offer-pattern"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item55")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        Offer Banner
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/hot-deal" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/hot-deal"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item55")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        Hot Deal
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/new-arrival" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/new-arrival"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item270")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        New Arrival
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/promises" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/promises"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item270")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        Promises
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/best-seller" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/best-seller"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item55")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        Best Seller
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/recently-viewed" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/recently-viewed"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item55")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        Recently Viewed
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/footer-pattern" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/footer-pattern"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item20")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        Footer
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
              </List>
            )}
            {/* end master dropdown */}

            <Link to="/products-pattern" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/products-pattern"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item9_000")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg"></ListItemIcon>
                  <ListItemText className="custom-font">Products</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>

            <Link to="/product-details-pattern" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/product-details-pattern"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item9")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg"></ListItemIcon>
                  <ListItemText className="custom-font">
                    Product Details
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/relatedn-product-pattern" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/relatedn-product-pattern"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item9.2978")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg"></ListItemIcon>
                  <ListItemText className="custom-font">
                    Related Product
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>

            <Link to="/wishlist-pattern" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/wishlist-pattern"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item2")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">WishList</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>

            <Link to="/cart-pattern" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/cart-pattern"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item30")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg"></ListItemIcon>
                  <ListItemText className="custom-font">Cart</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/play-store-apps-link-pattern" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/play-store-apps-link-pattern"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item30")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg"></ListItemIcon>
                  <ListItemText className="custom-font">
                    Play Store App LInk
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )}
        {/* end website configuration */}

        {/* App configuration */}

        <ListItem disablePadding>
          <ListItemButton onClick={() => setOpen(!Open)}>
            <ListItemIcon>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.6667 6.81663V2.49996C16.6667 2.27895 16.5789 2.06698 16.4226 1.9107C16.2663 1.75442 16.0544 1.66663 15.8333 1.66663C15.6123 1.66663 15.4004 1.75442 15.2441 1.9107C15.0878 2.06698 15 2.27895 15 2.49996V6.81663C14.5174 6.9918 14.1004 7.31132 13.8057 7.73176C13.511 8.15221 13.3529 8.65319 13.3529 9.16663C13.3529 9.68006 13.511 10.181 13.8057 10.6015C14.1004 11.0219 14.5174 11.3415 15 11.5166V17.5C15 17.721 15.0878 17.9329 15.2441 18.0892C15.4004 18.2455 15.6123 18.3333 15.8333 18.3333C16.0544 18.3333 16.2663 18.2455 16.4226 18.0892C16.5789 17.9329 16.6667 17.721 16.6667 17.5V11.5166C17.1493 11.3415 17.5663 11.0219 17.861 10.6015C18.1557 10.181 18.3137 9.68006 18.3137 9.16663C18.3137 8.65319 18.1557 8.15221 17.861 7.73176C17.5663 7.31132 17.1493 6.9918 16.6667 6.81663ZM15.8333 9.99996C15.6685 9.99996 15.5074 9.95109 15.3704 9.85952C15.2333 9.76795 15.1265 9.6378 15.0634 9.48553C15.0004 9.33326 14.9839 9.1657 15.016 9.00405C15.0482 8.8424 15.1275 8.69391 15.2441 8.57737C15.3606 8.46083 15.5091 8.38146 15.6708 8.3493C15.8324 8.31715 16 8.33365 16.1522 8.39673C16.3045 8.4598 16.4347 8.56661 16.5262 8.70365C16.6178 8.84069 16.6667 9.00181 16.6667 9.16663C16.6667 9.38764 16.5789 9.5996 16.4226 9.75588C16.2663 9.91216 16.0544 9.99996 15.8333 9.99996ZM10.8333 11.8166V2.49996C10.8333 2.27895 10.7455 2.06698 10.5893 1.9107C10.433 1.75442 10.221 1.66663 10 1.66663C9.779 1.66663 9.56703 1.75442 9.41075 1.9107C9.25447 2.06698 9.16668 2.27895 9.16668 2.49996V11.8166C8.68405 11.9918 8.26706 12.3113 7.97238 12.7318C7.6777 13.1522 7.51961 13.6532 7.51961 14.1666C7.51961 14.6801 7.6777 15.181 7.97238 15.6015C8.26706 16.0219 8.68405 16.3415 9.16668 16.5166V17.5C9.16668 17.721 9.25447 17.9329 9.41075 18.0892C9.56703 18.2455 9.779 18.3333 10 18.3333C10.221 18.3333 10.433 18.2455 10.5893 18.0892C10.7455 17.9329 10.8333 17.721 10.8333 17.5V16.5166C11.316 16.3415 11.733 16.0219 12.0276 15.6015C12.3223 15.181 12.4804 14.6801 12.4804 14.1666C12.4804 13.6532 12.3223 13.1522 12.0276 12.7318C11.733 12.3113 11.316 11.9918 10.8333 11.8166ZM10 15C9.83519 15 9.67408 14.9511 9.53703 14.8595C9.39999 14.768 9.29318 14.6378 9.23011 14.4855C9.16704 14.3333 9.15053 14.1657 9.18269 14.004C9.21484 13.8424 9.29421 13.6939 9.41075 13.5774C9.5273 13.4608 9.67578 13.3815 9.83743 13.3493C9.99909 13.3172 10.1666 13.3337 10.3189 13.3967C10.4712 13.4598 10.6013 13.5666 10.6929 13.7037C10.7845 13.8407 10.8333 14.0018 10.8333 14.1666C10.8333 14.3876 10.7455 14.5996 10.5893 14.7559C10.433 14.9122 10.221 15 10 15ZM5.00001 5.14996V2.49996C5.00001 2.27895 4.91221 2.06698 4.75593 1.9107C4.59965 1.75442 4.38769 1.66663 4.16668 1.66663C3.94566 1.66663 3.7337 1.75442 3.57742 1.9107C3.42114 2.06698 3.33334 2.27895 3.33334 2.49996V5.14996C2.85072 5.32513 2.43373 5.64465 2.13904 6.0651C1.84436 6.48554 1.68628 6.98653 1.68628 7.49996C1.68628 8.01339 1.84436 8.51437 2.13904 8.93482C2.43373 9.35527 2.85072 9.67479 3.33334 9.84996V17.5C3.33334 17.721 3.42114 17.9329 3.57742 18.0892C3.7337 18.2455 3.94566 18.3333 4.16668 18.3333C4.38769 18.3333 4.59965 18.2455 4.75593 18.0892C4.91221 17.9329 5.00001 17.721 5.00001 17.5V9.84996C5.48264 9.67479 5.89963 9.35527 6.19431 8.93482C6.48899 8.51437 6.64707 8.01339 6.64707 7.49996C6.64707 6.98653 6.48899 6.48554 6.19431 6.0651C5.89963 5.64465 5.48264 5.32513 5.00001 5.14996ZM4.16668 8.33329C4.00186 8.33329 3.84074 8.28442 3.7037 8.19285C3.56666 8.10128 3.45985 7.97113 3.39678 7.81886C3.3337 7.66659 3.3172 7.49903 3.34936 7.33738C3.38151 7.17573 3.46088 7.02725 3.57742 6.9107C3.69396 6.79416 3.84245 6.71479 4.0041 6.68264C4.16575 6.65048 4.33331 6.66699 4.48558 6.73006C4.63785 6.79313 4.768 6.89994 4.85957 7.03698C4.95114 7.17402 5.00001 7.33514 5.00001 7.49996C5.00001 7.72097 4.91221 7.93293 4.75593 8.08921C4.59965 8.24549 4.38769 8.33329 4.16668 8.33329Z"
                  fill={
                    location.pathname === "/app-header12" ||
                    location.pathname === "/app/header" ||
                    location.pathname === "/app/slider" ||
                    location.pathname === "/app/category" ||
                    location.pathname === "/app/offer-banner" ||
                    location.pathname === "/app/product/hot-deal" ||
                    location.pathname === "/app/product/best-seller" ||
                    location.pathname === "/app/product/new-arrival" ||
                    location.pathname === "/app/promises" ||
                    location.pathname === "/app/tab-bar" ||
                    location.pathname === "/app/product" ||
                    location.pathname === "/app/product-details" ||
                    location.pathname === "/app/checkout" ||
                    location.pathname === "/app/menu"
                      ? "#F99F21"
                      : "white"
                  }
                />
              </svg>
            </ListItemIcon>
            <ListItemText className="link_tag_sidebar ">
              App Ui Configration
            </ListItemText>
            <span className="pe-3">
              {" "}
              {Open ? (
                <KeyboardArrowRightIcon className="fs-6 text-white" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6 text-white" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {Open && (
          <List>
            <Link className="link_tag">
              <ListItem
                className={
                  location.pathname === "/app-header12"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => setIsHomeOpen(!isHomeOpen)}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Home</ListItemText>
                  <span className="pe-3">
                    {" "}
                    {isHomeOpen ? (
                      <KeyboardArrowRightIcon className="fs-6 text-white" />
                    ) : (
                      <KeyboardArrowDownIcon className="fs-6 text-white" />
                    )}
                  </span>
                </ListItemButton>
              </ListItem>
            </Link>

            {isHomeOpen && (
              <List>
                <Link to="/app/header" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/app/header"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item17")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        1. Header
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/app/slider" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/app/slider"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item17")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        2. Slider
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/app/category" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/app/category"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item17")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        3. Category
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/app/offer-banner" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/app/offer-banner"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item17")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        4. Offer Banner
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/app/product/hot-deal" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/app/product/hot-deal"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item17")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        5. Hot Deal
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/app/product/best-seller" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/app/product/best-seller"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item17")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        6. Best Seller
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/app/product/new-arrival" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/app/product/new-arrival"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item17")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        7. New Arrival
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/app/promises" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/app/promises"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item17")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        8. Promises
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/app/tab-bar" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/app/tab-bar"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item17")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        9. Tab Bar
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
                <Link to="/app/splash-screen" className="link_tag">
                  <ListItem
                    className={
                      location.pathname === "/app/splash-screen"
                        ? "active"
                        : "bg_dashboard"
                    }
                    disablePadding
                    onClick={() => handleClick("item17")}
                  >
                    <ListItemButton>
                      <ListItemIcon></ListItemIcon>
                      <ListItemText className="custom-font">
                        10. Splash screen
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
              </List>
            )}

            {/* products */}
            <Link className="link_tag" to="/app/product">
              <ListItem
                className={
                  location.pathname === "/app/product"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Products</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            {/* products details*/}
            <Link className="link_tag" to="/app/product-details">
              <ListItem
                className={
                  location.pathname === "/app/product-details"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Products Details
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>

            <Link className="link_tag" to="/app/checkout">
              <ListItem
                className={
                  location.pathname === "/app/checkout"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">CheckOut</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )}
        {/*end App configuration */}

        {/* admin ui configration */}
        <ListItem disablePadding>
          <ListItemButton onClick={() => setAdminOpen(!adminOpen)}>
            <ListItemIcon>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.6667 6.81663V2.49996C16.6667 2.27895 16.5789 2.06698 16.4226 1.9107C16.2663 1.75442 16.0544 1.66663 15.8333 1.66663C15.6123 1.66663 15.4004 1.75442 15.2441 1.9107C15.0878 2.06698 15 2.27895 15 2.49996V6.81663C14.5174 6.9918 14.1004 7.31132 13.8057 7.73176C13.511 8.15221 13.3529 8.65319 13.3529 9.16663C13.3529 9.68006 13.511 10.181 13.8057 10.6015C14.1004 11.0219 14.5174 11.3415 15 11.5166V17.5C15 17.721 15.0878 17.9329 15.2441 18.0892C15.4004 18.2455 15.6123 18.3333 15.8333 18.3333C16.0544 18.3333 16.2663 18.2455 16.4226 18.0892C16.5789 17.9329 16.6667 17.721 16.6667 17.5V11.5166C17.1493 11.3415 17.5663 11.0219 17.861 10.6015C18.1557 10.181 18.3137 9.68006 18.3137 9.16663C18.3137 8.65319 18.1557 8.15221 17.861 7.73176C17.5663 7.31132 17.1493 6.9918 16.6667 6.81663ZM15.8333 9.99996C15.6685 9.99996 15.5074 9.95109 15.3704 9.85952C15.2333 9.76795 15.1265 9.6378 15.0634 9.48553C15.0004 9.33326 14.9839 9.1657 15.016 9.00405C15.0482 8.8424 15.1275 8.69391 15.2441 8.57737C15.3606 8.46083 15.5091 8.38146 15.6708 8.3493C15.8324 8.31715 16 8.33365 16.1522 8.39673C16.3045 8.4598 16.4347 8.56661 16.5262 8.70365C16.6178 8.84069 16.6667 9.00181 16.6667 9.16663C16.6667 9.38764 16.5789 9.5996 16.4226 9.75588C16.2663 9.91216 16.0544 9.99996 15.8333 9.99996ZM10.8333 11.8166V2.49996C10.8333 2.27895 10.7455 2.06698 10.5893 1.9107C10.433 1.75442 10.221 1.66663 10 1.66663C9.779 1.66663 9.56703 1.75442 9.41075 1.9107C9.25447 2.06698 9.16668 2.27895 9.16668 2.49996V11.8166C8.68405 11.9918 8.26706 12.3113 7.97238 12.7318C7.6777 13.1522 7.51961 13.6532 7.51961 14.1666C7.51961 14.6801 7.6777 15.181 7.97238 15.6015C8.26706 16.0219 8.68405 16.3415 9.16668 16.5166V17.5C9.16668 17.721 9.25447 17.9329 9.41075 18.0892C9.56703 18.2455 9.779 18.3333 10 18.3333C10.221 18.3333 10.433 18.2455 10.5893 18.0892C10.7455 17.9329 10.8333 17.721 10.8333 17.5V16.5166C11.316 16.3415 11.733 16.0219 12.0276 15.6015C12.3223 15.181 12.4804 14.6801 12.4804 14.1666C12.4804 13.6532 12.3223 13.1522 12.0276 12.7318C11.733 12.3113 11.316 11.9918 10.8333 11.8166ZM10 15C9.83519 15 9.67408 14.9511 9.53703 14.8595C9.39999 14.768 9.29318 14.6378 9.23011 14.4855C9.16704 14.3333 9.15053 14.1657 9.18269 14.004C9.21484 13.8424 9.29421 13.6939 9.41075 13.5774C9.5273 13.4608 9.67578 13.3815 9.83743 13.3493C9.99909 13.3172 10.1666 13.3337 10.3189 13.3967C10.4712 13.4598 10.6013 13.5666 10.6929 13.7037C10.7845 13.8407 10.8333 14.0018 10.8333 14.1666C10.8333 14.3876 10.7455 14.5996 10.5893 14.7559C10.433 14.9122 10.221 15 10 15ZM5.00001 5.14996V2.49996C5.00001 2.27895 4.91221 2.06698 4.75593 1.9107C4.59965 1.75442 4.38769 1.66663 4.16668 1.66663C3.94566 1.66663 3.7337 1.75442 3.57742 1.9107C3.42114 2.06698 3.33334 2.27895 3.33334 2.49996V5.14996C2.85072 5.32513 2.43373 5.64465 2.13904 6.0651C1.84436 6.48554 1.68628 6.98653 1.68628 7.49996C1.68628 8.01339 1.84436 8.51437 2.13904 8.93482C2.43373 9.35527 2.85072 9.67479 3.33334 9.84996V17.5C3.33334 17.721 3.42114 17.9329 3.57742 18.0892C3.7337 18.2455 3.94566 18.3333 4.16668 18.3333C4.38769 18.3333 4.59965 18.2455 4.75593 18.0892C4.91221 17.9329 5.00001 17.721 5.00001 17.5V9.84996C5.48264 9.67479 5.89963 9.35527 6.19431 8.93482C6.48899 8.51437 6.64707 8.01339 6.64707 7.49996C6.64707 6.98653 6.48899 6.48554 6.19431 6.0651C5.89963 5.64465 5.48264 5.32513 5.00001 5.14996ZM4.16668 8.33329C4.00186 8.33329 3.84074 8.28442 3.7037 8.19285C3.56666 8.10128 3.45985 7.97113 3.39678 7.81886C3.3337 7.66659 3.3172 7.49903 3.34936 7.33738C3.38151 7.17573 3.46088 7.02725 3.57742 6.9107C3.69396 6.79416 3.84245 6.71479 4.0041 6.68264C4.16575 6.65048 4.33331 6.66699 4.48558 6.73006C4.63785 6.79313 4.768 6.89994 4.85957 7.03698C4.95114 7.17402 5.00001 7.33514 5.00001 7.49996C5.00001 7.72097 4.91221 7.93293 4.75593 8.08921C4.59965 8.24549 4.38769 8.33329 4.16668 8.33329Z"
                  fill={
                    location.pathname === "/admin/menu" ? "#F99F21" : "white"
                  }
                />
              </svg>
            </ListItemIcon>
            <ListItemText className="link_tag_sidebar ">
              Admin Ui Configration
            </ListItemText>
            <span className="pe-3">
              {" "}
              {adminOpen ? (
                <KeyboardArrowRightIcon className="fs-6 text-white" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6 text-white" />
              )}
            </span>
          </ListItemButton>
        </ListItem>

        {adminOpen && (
          <List>
            <Link to="/admin/menu" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/admin/menu"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item17")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    1. Sidebar Menu
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )}
        <Link to="/gallery" className="link_tag">
          <ListItem
            className={
              location.pathname === "/gallery" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item9_00")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.6667 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5ZM9.16667 15.8333H4.16667V10.8333H9.16667V15.8333ZM9.16667 9.16667H4.16667V4.16667H9.16667V9.16667ZM15.8333 15.8333H10.8333V10.8333H15.8333V15.8333ZM15.8333 9.16667H10.8333V4.16667H15.8333V9.16667Z"
                    fill={
                      location.pathname === "/gallery" ? "#F99F21" : "white"
                    }
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Gallery</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <ListItem disablePadding>
          <ListItemButton onClick={() => setPagesOpen(!PagesOpen)}>
            <ListItemIcon>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.7667 7.9583L16.1917 7.4333L16.9333 5.94996C17.0085 5.7947 17.0337 5.61993 17.0053 5.44977C16.9769 5.27961 16.8965 5.12245 16.775 4.99996L15 3.22496C14.8769 3.1017 14.7182 3.02013 14.5463 2.99173C14.3744 2.96333 14.1979 2.98953 14.0417 3.06663L12.5583 3.8083L12.0333 2.2333C11.9779 2.06912 11.8726 1.92632 11.7322 1.82475C11.5918 1.72319 11.4233 1.66792 11.25 1.66663H8.74999C8.57529 1.66618 8.40486 1.72064 8.2628 1.82233C8.12074 1.92402 8.01423 2.06778 7.95833 2.2333L7.43333 3.8083L5.94999 3.06663C5.79473 2.99145 5.61996 2.9663 5.4498 2.99466C5.27964 3.02302 5.12248 3.10349 4.99999 3.22496L3.22499 4.99996C3.10173 5.1231 3.02016 5.28177 2.99176 5.45368C2.96336 5.62558 2.98956 5.80205 3.06666 5.9583L3.80833 7.44163L2.23333 7.96663C2.06915 8.02208 1.92635 8.12732 1.82478 8.26772C1.72322 8.40812 1.66795 8.57668 1.66666 8.74996V11.25C1.66621 11.4247 1.72068 11.5951 1.82236 11.7372C1.92405 11.8792 2.06781 11.9857 2.23333 12.0416L3.80833 12.5666L3.06666 14.05C2.99148 14.2052 2.96633 14.38 2.99469 14.5502C3.02305 14.7203 3.10352 14.8775 3.22499 15L4.99999 16.775C5.12313 16.8982 5.28181 16.9798 5.45371 17.0082C5.62561 17.0366 5.80208 17.0104 5.95833 16.9333L7.44166 16.1916L7.96666 17.7666C8.02256 17.9321 8.12907 18.0759 8.27114 18.1776C8.4132 18.2793 8.58362 18.3337 8.75833 18.3333H11.2583C11.433 18.3337 11.6035 18.2793 11.7455 18.1776C11.8876 18.0759 11.9941 17.9321 12.05 17.7666L12.575 16.1916L14.0583 16.9333C14.2126 17.0066 14.3857 17.0307 14.5541 17.0024C14.7225 16.9741 14.8782 16.8947 15 16.775L16.775 15C16.8983 14.8768 16.9798 14.7182 17.0082 14.5463C17.0366 14.3743 17.0104 14.1979 16.9333 14.0416L16.1917 12.5583L17.7667 12.0333C17.9308 11.9778 18.0736 11.8726 18.1752 11.7322C18.2768 11.5918 18.332 11.4232 18.3333 11.25V8.74996C18.3338 8.57526 18.2793 8.40483 18.1776 8.26277C18.0759 8.12071 17.9322 8.0142 17.7667 7.9583ZM16.6667 10.65L15.6667 10.9833C15.4367 11.0579 15.2257 11.1816 15.0484 11.3459C14.871 11.5102 14.7315 11.711 14.6395 11.9346C14.5476 12.1582 14.5054 12.3991 14.5158 12.6406C14.5262 12.8821 14.5891 13.1185 14.7 13.3333L15.175 14.2833L14.2583 15.2L13.3333 14.7C13.1196 14.5935 12.8855 14.5342 12.6469 14.526C12.4083 14.5179 12.1707 14.5611 11.9503 14.6528C11.7298 14.7445 11.5316 14.8824 11.3691 15.0573C11.2066 15.2322 11.0836 15.44 11.0083 15.6666L10.675 16.6666H9.34999L9.01666 15.6666C8.94207 15.4367 8.81835 15.2257 8.65408 15.0483C8.4898 14.871 8.28891 14.7315 8.06534 14.6395C7.84177 14.5475 7.60087 14.5053 7.35935 14.5158C7.11782 14.5262 6.88146 14.5891 6.66666 14.7L5.71666 15.175L4.79999 14.2583L5.29999 13.3333C5.4109 13.1185 5.47376 12.8821 5.4842 12.6406C5.49464 12.3991 5.45241 12.1582 5.36044 11.9346C5.26848 11.711 5.12897 11.5102 4.95161 11.3459C4.77425 11.1816 4.56328 11.0579 4.33333 10.9833L3.33333 10.65V9.34996L4.33333 9.01663C4.56328 8.94204 4.77425 8.81832 4.95161 8.65404C5.12897 8.48977 5.26848 8.28888 5.36044 8.06531C5.45241 7.84174 5.49464 7.60084 5.4842 7.35932C5.47376 7.11779 5.4109 6.88143 5.29999 6.66663L4.82499 5.74163L5.74166 4.82496L6.66666 5.29996C6.88146 5.41087 7.11782 5.47373 7.35935 5.48417C7.60087 5.49461 7.84177 5.45238 8.06534 5.36041C8.28891 5.26845 8.4898 5.12894 8.65408 4.95158C8.81835 4.77422 8.94207 4.56325 9.01666 4.3333L9.34999 3.3333H10.65L10.9833 4.3333C11.0579 4.56325 11.1816 4.77422 11.3459 4.95158C11.5102 5.12894 11.7111 5.26845 11.9346 5.36041C12.1582 5.45238 12.3991 5.49461 12.6406 5.48417C12.8822 5.47373 13.1185 5.41087 13.3333 5.29996L14.2833 4.82496L15.2 5.74163L14.7 6.66663C14.5935 6.88033 14.5342 7.11442 14.5261 7.35304C14.5179 7.59165 14.5612 7.82924 14.6528 8.0497C14.7445 8.27016 14.8824 8.46835 15.0574 8.63086C15.2323 8.79337 15.4401 8.9164 15.6667 8.99163L16.6667 9.32496V10.65ZM9.99999 6.66663C9.34072 6.66663 8.69626 6.86213 8.14809 7.2284C7.59993 7.59467 7.17269 8.11526 6.92039 8.72435C6.6681 9.33344 6.60209 10.0037 6.73071 10.6503C6.85933 11.2969 7.1768 11.8908 7.64297 12.357C8.10915 12.8232 8.70309 13.1406 9.34969 13.2692C9.99629 13.3979 10.6665 13.3319 11.2756 13.0796C11.8847 12.8273 12.4053 12.4 12.7716 11.8519C13.1378 11.3037 13.3333 10.6592 13.3333 9.99996C13.3333 9.11591 12.9821 8.26806 12.357 7.64294C11.7319 7.01782 10.884 6.66663 9.99999 6.66663ZM9.99999 11.6666C9.67036 11.6666 9.34812 11.5689 9.07404 11.3857C8.79996 11.2026 8.58634 10.9423 8.46019 10.6378C8.33405 10.3332 8.30104 9.99811 8.36535 9.67481C8.42966 9.35151 8.58839 9.05454 8.82148 8.82145C9.05457 8.58836 9.35154 8.42963 9.67484 8.36532C9.99814 8.30101 10.3333 8.33402 10.6378 8.46016C10.9423 8.58631 11.2026 8.79993 11.3858 9.07401C11.5689 9.34809 11.6667 9.67033 11.6667 9.99996C11.6667 10.442 11.4911 10.8659 11.1785 11.1785C10.8659 11.491 10.442 11.6666 9.99999 11.6666Z"
                  fill={
                    location.pathname === "/business-details" ||
                    location.pathname === "/smtp" ||
                    location.pathname === "/payment-gateway"
                      ? "#F99F21"
                      : "white"
                  }
                />
              </svg>
            </ListItemIcon>
            <ListItemText className="link_tag_sidebar ">
              Portal & Setting
            </ListItemText>
            <span className="pe-3">
              {" "}
              {PagesOpen ? (
                <KeyboardArrowRightIcon className="fs-6 text-white" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6 text-white" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {PagesOpen && (
          <List>
            <Link to="/business-details" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/business-details"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item17")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Business Details
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/smtp" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/smtp" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item17_7")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">SMTP</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/payment-gateway" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/payment-gateway"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item17")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Payment Gateway
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/setting/push-notification" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/setting/push-notification"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item9_00")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg"></ListItemIcon>
                  <ListItemText className="custom-font">
                    Push Notification Setting
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/setting/whatsapp-setting" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/setting/whatsapp-setting"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item9_00")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg"></ListItemIcon>
                  <ListItemText className="custom-font">
                    Whatsapp Setting
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link className="link_tag" to="/app/menu">
              <ListItem
                className={
                  location.pathname === "/app/menu" ? "active" : "bg_dashboard"
                }
                disablePadding
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Menu</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      {!isLoginPage && (
        <>
          <CssBaseline />
          <AppBar
            position="fixed"
            sx={{
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              ml: { sm: `${drawerWidth}px` },
            }}
          >
            <Toolbar
              sx={{
                display: "flex",
                justifyContent: "space-between",
                height: "40px",
                backgroundColor: "#FFFFFF",
                hideClasses,
              }}
            >
              <div className="d-flex align-items-center">
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { sm: "none" } }}
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" noWrap component="div">
                  <div className="me-2 admin_title_header">
                    <div>
                      <h5 className="header_heading">welcome back,</h5>
                      <p className="time_header_para">
                        <span style={{ color: "#181818" }}>{day}</span>,{" "}
                        {restDateTime}
                      </p>
                    </div>
                  </div>{" "}
                </Typography>
              </div>

              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  {/* Profile Dropdown */}
                  <IconButton
                    onClick={handleProfileClick}
                    aria-controls="profile-menu"
                    aria-haspopup="true"
                    color="inherit"
                  >
                    {/* <MoreVertIcon /> */}
                    <svg
                      width={35}
                      height={35}
                      viewBox="0 0 35 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="17.375"
                        cy="17.375"
                        r="17.375"
                        fill="#F4F4F4"
                      />
                      <mask
                        id="mask0_47_31"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x={8}
                        y={8}
                        width={19}
                        height={19}
                      >
                        <rect
                          x="8.6875"
                          y="8.6875"
                          width="17.375"
                          height="17.375"
                          fill="#D9D9D9"
                        />
                      </mask>
                      <g mask="url(#mask0_47_31)">
                        <path
                          d="M17.375 17.375C16.5786 17.375 15.8969 17.0915 15.3298 16.5244C14.7627 15.9573 14.4791 15.2755 14.4791 14.4792C14.4791 13.6828 14.7627 13.0011 15.3298 12.434C15.8969 11.8669 16.5786 11.5833 17.375 11.5833C18.1713 11.5833 18.8531 11.8669 19.4202 12.434C19.9873 13.0011 20.2708 13.6828 20.2708 14.4792C20.2708 15.2755 19.9873 15.9573 19.4202 16.5244C18.8531 17.0915 18.1713 17.375 17.375 17.375ZM11.5833 23.1667V21.1396C11.5833 20.7293 11.6889 20.3523 11.9 20.0084C12.1112 19.6645 12.3917 19.4021 12.7416 19.2211C13.4897 18.8471 14.2499 18.5665 15.0221 18.3795C15.7943 18.1925 16.5786 18.099 17.375 18.099C18.1713 18.099 18.9556 18.1925 19.7278 18.3795C20.5001 18.5665 21.2602 18.8471 22.0083 19.2211C22.3582 19.4021 22.6388 19.6645 22.8499 20.0084C23.0611 20.3523 23.1666 20.7293 23.1666 21.1396V23.1667H11.5833Z"
                          fill="#808080"
                        />
                      </g>
                    </svg>
                  </IconButton>
                  <Menu
                    id="profile-menu"
                    className=""
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleCloseProfile}
                  >
                    <Link
                      to="/edit_profile"
                      className="text-decoration-none text-dark"
                    >
                      {" "}
                      <MenuItem onClick={handleCloseProfile}>
                        Edit Profile{" "}
                      </MenuItem>
                    </Link>
                    <Link
                      to="/change_password"
                      className="text-decoration-none text-dark"
                    >
                      {" "}
                      <MenuItem onClick={handleCloseProfile}>
                        Change Password
                      </MenuItem>
                    </Link>
                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                  </Menu>
                </div>
              </div>
            </Toolbar>
          </AppBar>
          <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
          >
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                display: { xs: "block", sm: "none" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  backgroundColor: "#181818",
                },
              }}
            >
              {!isLoginPage && <>{drawer}</>}
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: "none", sm: "block" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  backgroundColor: "#181818",
                  height: "100%", // Ensures the drawer takes full height of the screen
                  overflowY: "auto", // Enables scrolling inside the drawer if content overflows
                  /* Custom scrollbar styling */
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    borderRadius: "8px", // Thumb roundness
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888", // Thumb color
                    borderRadius: "8px", // Thumb roundness
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#555",
                  },
                  scrollbarWidth: "thin",
                  scrollbarColor: "#ffffff #cfc9c9",
                },
              }}
              open
            >
              {!isLoginPage && <>{drawer}</>}
            </Drawer>
          </Box>
        </>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        {!isLoginPage && (
          <>
            <Toolbar />
          </>
        )}
        <Routing />
      </Box>
    </Box>
  );
}
